module.exports = __webpack_public_path__ + "pic/70.b15a2994.png";